import React from 'react';
import PropTypes from 'prop-types';
import renderHtml from 'react-render-html';
import { AGES } from '../../data/ageGroups';
import CheckboxButton from '../Global/Forms/CheckboxButton';

const AgeGroupCTA = ({ loggedInUser, onChange, values, submitting }) => {
  const checkboxTitleClass = 'like-h3 m-b-0';
  let bodyText;
  let cta;

  if (loggedInUser.notLoggedIn) {
    bodyText = 'Sign up to The Coaching Manual to tell use which age group (or groups) you coach and we will tailor the content you see on the Training Ground and in Search. You will still be able to search for other content aimed at other ages.';
    cta = <a href="/signup" className="btn btn--l">Sign up for free</a>;
  } else {
    bodyText = renderHtml('Tell us which age group (or groups) you coach and we will tailor the content you see on the Training Ground and in Search. You will still be able to search for other content aimed at other ages. You can change your preferences on your <a href="/account/details" className="link">Account Details</a> page.');
    cta = (
      <div className="d-flex">
        {AGES.map(coachAge => (
          <div key={coachAge.displayName} className="age-group-cta__checkbox flex-1">
            <CheckboxButton name="ageGroup" value={coachAge.value} onChange={onChange} checked={values.includes(coachAge.value)} disabled={submitting}>
              <span className={checkboxTitleClass}>{coachAge.displayName}</span>
            </CheckboxButton>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="age-group-cta border-radius-l border-1 border-color-grey--light border-top-4 border-top-color-green box-shadow-l overflow-hidden">
      <div className="row">
        <div className="col-lg-6">
          <div className="age-group-cta__text">
            <h2 className="like-h3 m-b-3">Spend less time searching and more time delivering out on the pitch</h2>
            <p className="like-h5 color-grey m-b-4">{bodyText}</p>
            {cta}
          </div>
        </div>

        <div className="col-lg-6 hidden-md-down">
          <div className="age-group-cta__image background-size-cover height-100 background-position-center" style={{ backgroundImage: 'url(https://storage.googleapis.com/tcm-coachingmanual-v3.appspot.com/training-ground/age-group-cta.jpg)' }} />
        </div>
      </div>
    </div>
  );
};

AgeGroupCTA.propTypes = {
  loggedInUser: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.array.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default AgeGroupCTA;



// WEBPACK FOOTER //
// ./library/app/components/TrainingGround/AgeGroupCTA.js